var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgContent = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "data"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25 18.4375C23.1 18.4375 21.5625 16.9 21.5625 15C21.5625 13.1 23.1 11.5625 25 11.5625C26.9 11.5625 28.4375 13.1 28.4375 15C28.4375 16.9 26.9 18.4375 25 18.4375ZM25 13.4375C24.1375 13.4375 23.4375 14.1375 23.4375 15C23.4375 15.8625 24.1375 16.5625 25 16.5625C25.8625 16.5625 26.5625 15.8625 26.5625 15C26.5625 14.1375 25.8625 13.4375 25 13.4375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25 8.4375C23.1 8.4375 21.5625 6.9 21.5625 5C21.5625 3.1 23.1 1.5625 25 1.5625C26.9 1.5625 28.4375 3.1 28.4375 5C28.4375 6.9 26.9 8.4375 25 8.4375ZM25 3.4375C24.1375 3.4375 23.4375 4.1375 23.4375 5C23.4375 5.8625 24.1375 6.5625 25 6.5625C25.8625 6.5625 26.5625 5.8625 26.5625 5C26.5625 4.1375 25.8625 3.4375 25 3.4375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25 28.4375C23.1 28.4375 21.5625 26.9 21.5625 25C21.5625 23.1 23.1 21.5625 25 21.5625C26.9 21.5625 28.4375 23.1 28.4375 25C28.4375 26.9 26.9 28.4375 25 28.4375ZM25 23.4375C24.1375 23.4375 23.4375 24.1375 23.4375 25C23.4375 25.8625 24.1375 26.5625 25 26.5625C25.8625 26.5625 26.5625 25.8625 26.5625 25C26.5625 24.1375 25.8625 23.4375 25 23.4375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5 18.4375C3.1 18.4375 1.5625 16.9 1.5625 15C1.5625 13.1 3.1 11.5625 5 11.5625C6.9 11.5625 8.4375 13.1 8.4375 15C8.4375 16.9 6.9 18.4375 5 18.4375ZM5 13.4375C4.1375 13.4375 3.4375 14.1375 3.4375 15C3.4375 15.8625 4.1375 16.5625 5 16.5625C5.8625 16.5625 6.5625 15.8625 6.5625 15C6.5625 14.1375 5.8625 13.4375 5 13.4375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M22.5 15.9375H7.5C6.9875 15.9375 6.5625 15.5125 6.5625 15C6.5625 14.4875 6.9875 14.0625 7.5 14.0625H22.5C23.0125 14.0625 23.4375 14.4875 23.4375 15C23.4375 15.5125 23.0125 15.9375 22.5 15.9375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M22.5 25.9375H17.5C14.475 25.9375 12.8125 24.275 12.8125 21.25V8.75C12.8125 5.725 14.475 4.0625 17.5 4.0625H22.5C23.0125 4.0625 23.4375 4.4875 23.4375 5C23.4375 5.5125 23.0125 5.9375 22.5 5.9375H17.5C15.525 5.9375 14.6875 6.775 14.6875 8.75V21.25C14.6875 23.225 15.525 24.0625 17.5 24.0625H22.5C23.0125 24.0625 23.4375 24.4875 23.4375 25C23.4375 25.5125 23.0125 25.9375 22.5 25.9375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_7",
    opacity: 0
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgContent);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/content.2d0e73808d00890db59d0fcf8dfc4013.svg";